class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      if (this.dataset.attached && this.dataset.attached != '') {
        const updateProducts = {}
        if (this.dataset.attached != "") {
          this.dataset.attached.split(';').map(attached => {
            const attached_id = attached.trim();
            if (attached_id != "") {
              updateProducts[attached_id] = 0
            }
          })
        }
        updateProducts[this.dataset.key] = 0;
        try {
          fetch(routes.cart_update_url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              updates: updateProducts
            })
          }).then(response => {
            this.closest('cart-drawer').fetchCart();
          })
            .catch((error) => {
              console.log(error)
            })
        } catch (error) {
          console.log(error)
        }
      } else {
        this.closest('cart-drawer').updateQuantity(this.dataset.index, 0);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    const index = event.target.dataset.index;
    const quantity = event.target.value;
    const name = document.activeElement.getAttribute('name');
  
    const removeBtn = this.querySelector(`#Remove-${index}`);
    const platformKey = removeBtn?.dataset.platformKey || '';
  
    if (platformKey) {
      fetch(routes.cart_update_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [platformKey]: parseInt(quantity) } })
      }).finally(() => {
        this.updateQuantity(index, quantity, name);
      });
    } else {
      this.updateQuantity(index, quantity, name);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: 'main-cart-items',
        selector: '.js-contents'
      }
    ];
  }

  connectedCallback() {
    this.body = document.querySelector('body');
    this.drawer = document.getElementById('shopify-section-cart-drawer');
    this.overlay = document.getElementById('cart-overlay');
    this.outer = document.getElementById('cart-drawer-outer');
    this.cartContents = document.querySelector('.cart__contents');
    this.revealBtn = document.getElementById('cart-reveal');
    this.subtotal = document.getElementById('cart-subtotal');
    this.cartCount = document.querySelector('.cart__indicator');

    this.fetchAndOpenCart = this.fetchAndOpenCart.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);


    this.revealBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.fetchAndOpenCart();
    })

    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.closeDrawer.bind(this))
    );

    this.overlay.addEventListener('click', (e) => {
      this.closeDrawer();
    })

  }

  fetchCart(callback) {
    fetch('/cart.js', {
      credentials: 'same-origin',
      method: 'GET',
    })
      .then((resp) => resp.json())
      .then((cart) => {
        if (cart.items.length !== 0) {
          this.outer.classList.remove('is-empty');
          this.renderCart(cart);
        } else if (cart.items.length === 0) {
          this.outer.classList.add('is-empty');
          this.renderCart(cart);
        }
        this.checkSetupFeeInCart(cart)
        if ((typeof callback) === 'function') {
          callback(cart);
        }
      })
      .catch((error) => {
        throw new Error(error);
      });
  }

  updateQuantity(line, quantity, name) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        if (response.status === 422) {
          throw new Error(response.statusText);
        } else {
          return response.text();
        }
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.outer.classList.toggle('is-empty', parsedState.item_count === 0);

        this.subtotal.innerHTML = `$${(parsedState.items_subtotal_price / 100).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;


        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        const lineItem = document.getElementById(`cart-product-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.updateCartCount();
        this.checkSetupFeeInCart(parsedState)
      })
      .catch((err) => {
        if (name == 'plus') {
          const lineItem = this.querySelector(`#cart-product-${line}`);
          lineItem.querySelector('.quantity-input').value = quantity - 1
          lineItem.querySelector('.error__message').classList.remove('hidden');
        }
        console.error(window.cartStrings.error);
      })
  }

  renderCart(cart) {
    fetch(`${window.location.pathname}?sections=main-cart-items`)
      .then(response => response.json())
      .then(parsedState => {
        
        this.subtotal.innerText = `$${(cart.items_subtotal_price / 100).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
        this.cartContents.innerHTML = this.getSectionInnerHTML(parsedState['main-cart-items'], '.js-contents');
        this.updateCartCount();
      })
      .catch((e) => {
        console.error(e);
      })
  }

  updateCartCount() {
    this.cartItemCount = document.querySelector('[data-cart-length]') ? document.querySelector('[data-cart-length]').dataset.cartLength : null;
    this.cartCount.innerHTML = this.cartItemCount ? parseInt(this.cartItemCount, 10) : null;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  openDrawer() {
    this.body.classList.add('model-active');
    this.drawer.classList.add('is-active');
  }

  closeDrawer() {
    this.body.classList.remove('model-active');
    this.drawer.classList.remove('is-active');
  }

  fetchAndOpenCart() {
    this.fetchCart(() => {
      this.openDrawer();
    });
  }

  checkSetupFeeInCart(cart, event) {
    if (cart.items.length === 0) return;
    let wallpaperMinimumItems = [];
    for (var i=0; i < cart.items.length; i++) {
      if (cart.items[i].properties['_wallpaper_minimum']) {
        const itemTitle = cart.items[i].title.replace("- Yardage", "");
        wallpaperMinimumItems.push({
          id: cart.items[i].id,
          quantity: cart.items[i].quantity,
          title: itemTitle,
          variantTitle: cart.items[i].variant_title
        });
      }
    }

    if (!wallpaperMinimumItems.length) return;
    const setupFeeItems = cart.items.filter((x) => x.id == '40628503150652');
    const updateProducts = {};
    const itemAdd = [];
    
    wallpaperMinimumItems.forEach((wallpaper) => { 
      let isSetupFeeInCart = false;
      let countUnder20 = 0;
      let countPanelsUnder5 = 0;
      let totalCount = 0;
      let feeKey = '';
      let feeCount = 0;
      setupFeeItems.forEach((fee) => {
        const matchingProductId = fee.properties['_product_id'];
        if (fee.properties['_product_id'] == wallpaper.id) {
          countPanelsUnder5 = wallpaperMinimumItems.filter(x => 
            x.variantTitle.includes('Panels') && 
            x.id === matchingProductId && x.quantity <= 5
          ).length;
          
          countUnder20 = wallpaperMinimumItems.filter(x =>
            x.id === matchingProductId &&
            x.quantity < 20 && !x.variantTitle.includes('Panels')
          ).length;

          feeKey = fee.key;
          isSetupFeeInCart = true;
          feeCount = fee.quantity;
          totalCount = countPanelsUnder5 + countUnder20;
        }
      })
      
      if (feeKey != '' && feeCount != totalCount) {
        updateProducts[feeKey] = totalCount;
      }
      
      let isWallPaperAdd = false;
      if (wallpaper.quantity < 20 && !wallpaper.variantTitle.includes('Panels')) {
        isWallPaperAdd = true;
      } else if (wallpaper.quantity <= 5 && wallpaper.variantTitle.includes('Panels')) {
        isWallPaperAdd = true;
      }
      if (!isSetupFeeInCart && isWallPaperAdd) {
        itemAdd.push({
          id: 40628503150652,
          quantity: 1,
          properties: {
            _product_id: wallpaper.id,
            _product_title: wallpaper.title,
            "Setup Fee": wallpaper.title,
          }
        })
      }
    })

    if (Object.keys(updateProducts).length) {
      try {
        fetch(routes.cart_update_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: updateProducts
          })
        }).then(response => {
          this.closest('cart-drawer').fetchCart();
        })
          .catch((error) => {
            console.log(error)
          })
      } catch (error) {
        console.log(error)
      }
    }

    if (!itemAdd.length) return;
    const additionalProductsConfig = fetchConfig("javascript");
    additionalProductsConfig.body = JSON.stringify({
      items: itemAdd,
    });
    fetch(`${routes.cart_add_url}`, additionalProductsConfig)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return response.status;
        }
      })
      .finally(() => {
        this.closest('cart-drawer').fetchCart();
      });
  }
}

customElements.define('cart-drawer', CartDrawer);
